import React from 'react';
import Shell from '../Shell';

import Route from './Route';

function PrivateRoute({ title, breadcrumbs, ...props }) {
  return <Shell title={title} breadcrumbs={breadcrumbs}>
    <Route {...props} priv authorize />
  </Shell>;
}

export default PrivateRoute;
